import React from 'react';
import { Link } from 'react-router-dom';
import { STATUS_LABELS, PRIORITY_LABELS } from '../services/api';

export const StatusBadge = ({ status }) => {
  const cfg = STATUS_LABELS[status] || { label: status, color: 'bg-slate-100 text-slate-800 border-slate-200' };
  return <span className={`inline-flex items-center px-2.5 py-1 text-xs font-medium border rounded ${cfg.color}`}>{cfg.label}</span>;
};

export const PriorityBadge = ({ priority }) => {
  const cfg = PRIORITY_LABELS[priority] || { label: priority, color: 'text-slate-700 bg-slate-50 border-slate-200' };
  return <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium border rounded ${cfg.color}`}>{cfg.label}</span>;
};

export const PageHeader = ({ title, description, actions }) => (
  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-6">
    <div className="min-w-0">
      <h1 className="text-2xl md:text-3xl font-display uppercase text-slate-900 tracking-tight">{title}</h1>
      {description && <p className="text-sm text-slate-600 mt-1">{description}</p>}
    </div>
    {actions && (
      <div className="flex flex-wrap items-center gap-2 sm:justify-end sm:shrink-0">
        {actions}
      </div>
    )}
  </div>
);

export const StatCard = ({ icon: Icon, label, value, hint, accent = 'slate', to, testId }) => {
  const accents = {
    slate: 'bg-slate-100 text-slate-700',
    amber: 'bg-blue-100 text-blue-700',
    green: 'bg-green-100 text-green-700',
    red: 'bg-red-100 text-red-700',
    blue: 'bg-blue-100 text-blue-700',
  };
  // Whole tile is clickable when `to` is set. Using Link rather than a
  // click-handler keeps cmd/ctrl-click-to-open-new-tab and middle-click
  // working for free, plus it's a real href for screen readers.
  const Wrapper = to ? Link : 'div';
  const wrapperProps = to
    ? { to, className: 'bg-white border border-slate-200 rounded-md p-5 block hover:shadow-md hover:border-slate-300 transition-all cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500', 'data-testid': testId || `stat-card-${label.toLowerCase().replace(/\s+/g, '-')}` }
    : { className: 'bg-white border border-slate-200 rounded-md p-5 hover:shadow-sm transition-shadow', 'data-testid': testId };
  return (
    <Wrapper {...wrapperProps}>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs font-medium uppercase tracking-wider text-slate-500">{label}</div>
          <div className="text-3xl font-bold text-slate-900 mt-1">{value}</div>
          {hint && <div className="text-xs text-slate-500 mt-1">{hint}</div>}
        </div>
        {Icon && <div className={`h-10 w-10 rounded-md flex items-center justify-center ${accents[accent]}`}><Icon className="h-5 w-5" /></div>}
      </div>
    </Wrapper>
  );
};
